<template>
    <v-navigation-drawer
        v-model="drawer"
        app
        color="grey lighten-4"
        :mini-variant.sync="mini"
        permanent
        v-if="!operatorRole"
        clipped
        stateless
        :expand-on-hover="!$vuetify.breakpoint.smAndDown ? true : false"
    >
        <div class="nav-drawer-inner fill-height d-flex flex-column">
            <div
                class="nav-drawer-header d-flex justify-space-between align-center mt-2 px-2"
            >
                <v-img
                    :src="companyLogo"
                    class="pa-0 ma-0"
                    max-height="60"
                    width="50%"
                    xs="56"
                    sm="56"
                    contain
                />
                <v-btn
                    v-if="!mini && $vuetify.breakpoint.smAndDown"
                    icon
                    @click.stop="closeMenu"
                >
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
            </div>
            <v-list
                dense
                nav
                rounded
                class="nav-drawer-list flex-grow-1 overflow-y-auto"
            >
                <v-list-group
                    :value="salesGroup"
                    prepend-icon="mdi-account-tie"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-item-title @click.stop="toggleGroup('sales')">
                            SALES
                        </v-list-item-title>
                    </template>
                    <v-list-item
                        v-for="item in saleItems"
                        :key="item.title"
                        color="primary"
                        :to="item.path"
                        :input-value="isItemActive(item.path)"
                        active-class="nav-drawer-item--active"
                        link
                        @click="dismissDrawer('sales')"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title.toUpperCase() }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-group
                    v-if="engineerItems.length > 0"
                    :value="engineerGroup"
                    prepend-icon="mdi-account-cog"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-item-title
                            @click.stop="toggleGroup('engineer')"
                        >
                            ENGINEERING
                        </v-list-item-title>
                    </template>
                    <v-list-item
                        v-for="item in engineerItems"
                        :key="item.title"
                        color="primary"
                        :to="item.path"
                        :input-value="isItemActive(item.path)"
                        active-class="nav-drawer-item--active"
                        link
                        @click="dismissDrawer('engineer')"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title.toUpperCase() }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-group
                    :value="projectGroup"
                    prepend-icon="mdi-account-hard-hat"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-item-title
                            @click.stop="toggleGroup('projects')"
                        >
                            PROJECTS
                        </v-list-item-title>
                    </template>
                    <v-list-item
                        v-for="item in projectsItems"
                        :key="item.title"
                        color="primary"
                        :to="item.path"
                        :input-value="isItemActive(item.path)"
                        active-class="nav-drawer-item--active"
                        link
                        @click="dismissDrawer('projects')"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title.toUpperCase() }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-group :value="productionGroup" no-action>
                    <template v-slot:prependIcon>
                        <v-badge
                            :value="alertsCount > 0"
                            :content="alertsCount"
                            color="red"
                            overlap
                            offset-x="10"
                            offset-y="10"
                        >
                            <v-icon>mdi-hammer-screwdriver</v-icon>
                        </v-badge>
                    </template>
                    <template v-slot:activator>
                        <v-list-item-title
                            @click.stop="toggleGroup('production')"
                        >
                            OPERATIONS
                        </v-list-item-title>
                    </template>
                    <v-list-item
                        v-for="item in productionItems"
                        :key="item.title"
                        color="primary"
                        :to="item.path"
                        :input-value="isItemActive(item.path)"
                        active-class="nav-drawer-item--active"
                        link
                        @click="dismissDrawer('production')"
                    >
                        <v-list-item-icon>
                            <v-badge
                                v-if="
                                    item.title === 'Work Orders' &&
                                        alertsCount > 0
                                "
                                :content="alertsCount"
                                color="red"
                                overlap
                                offset-x="10"
                                offset-y="10"
                            >
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-badge>
                            <v-icon v-else>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title.toUpperCase() }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-group
                    v-if="tasks"
                    :value="tasksGroup"
                    prepend-icon="mdi-list-box"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-item-title @click.stop="toggleGroup('tasks')">
                            TASKS
                        </v-list-item-title>
                    </template>
                    <v-list-item
                        v-for="item in taskItems"
                        :key="item.title"
                        color="primary"
                        :to="item.path"
                        :input-value="isItemActive(item.path)"
                        active-class="nav-drawer-item--active"
                        link
                        @click="dismissDrawer('tasks')"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title.toUpperCase() }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-group
                    :value="settingsGroup"
                    prepend-icon="mdi-cog"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-item-title
                            @click.stop="toggleGroup('settings')"
                        >
                            SETTINGS
                        </v-list-item-title>
                    </template>
                    <v-list-item
                        v-for="item in settingsItems"
                        :key="item.title"
                        color="primary"
                        :to="item.path"
                        :input-value="isItemActive(item.path)"
                        active-class="nav-drawer-item--active"
                        link
                        @click="dismissDrawer('settings')"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title.toUpperCase() }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list>

            <v-spacer />

            <v-divider />

            <v-list class="nav-drawer-footer pa-0" dense>
                <v-progress-linear indeterminate v-if="loading" />
                <v-list-item link class="logout-item" @click="signOut">
                    <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>LOG OUT</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </div>
    </v-navigation-drawer>
</template>

<script>
import { auth, messaging, vapidKey, firestore } from '@/services/firebase'
import { mapActions, mapMutations, mapState } from 'vuex'
import API from '@/services/api'
import { isAccountingEnabled } from '@/utils/accountingCompanyConfig.js'

export default {
    name: 'NavDrawer',
    data() {
        return {
            salesGroup: false,
            engineerGroup: false,
            projectGroup: false,
            productionGroup: false,
            tasksGroup: true,
            settingsGroup: false,
            loading: false,
            drawer: true,
            mini: true,
            error: false,
            errorMsg: null,
            tasks: null,
            companyId: JSON.parse(localStorage.getItem('company')),
            alertsUnsubscribe: null,
            alertsCount: 0,
            taskItems: [
                {
                    title: 'Main Board',
                    icon: 'mdi-clipboard-outline',
                    path: '/tasks',
                },
                {
                    title: 'Assign Board',
                    icon: 'mdi-bulletin-board',
                    path: '/assign',
                },
                {
                    title: 'Archive',
                    icon: 'mdi-archive-outline',
                    path: '/archive-tasks',
                },
            ],
            saleItems: [
                {
                    title: 'Leads',
                    icon: 'mdi-handshake-outline',
                    path: '/leads',
                },
                {
                    title: 'Main Board',
                    icon: 'mdi-clipboard-outline',
                    path: '/main-board',
                },
                {
                    title: 'My Scopes',
                    icon: 'mdi-pencil-ruler-outline',
                    path: '/my-scopes',
                },
                {
                    title: 'Estimating Plan',
                    icon: 'mdi-file-check-outline',
                    path: '/estimating-plan',
                },
                {
                    title: 'Commercial Tools',
                    icon: 'mdi-image-multiple-outline',
                    path: '/tools',
                },
                {
                    title: 'Clients',
                    icon: 'mdi-office-building-outline',
                    path: '/clients',
                },
                {
                    title: 'Archive',
                    icon: 'mdi-archive-outline',
                    path: '/history',
                },
                // {
                //     title: 'Calculations',
                //     icon: 'mdi-alarm-panel-outline',
                //     path: '/calculations',
                // },
                {
                    title: 'Statistics',
                    icon: 'mdi-chart-line',
                    path: '/Statistics',
                },
                {
                    title: 'chats',
                    icon: 'mdi-forum-outline',
                    path: '/chats',
                },
            ],
            projectsItems: [
                {
                    title: 'Main Board',
                    icon: 'mdi-screw-machine-flat-top',
                    path: '/tab-projects',
                },
                {
                    title: 'Forecast',
                    icon: 'mdi-finance',
                    path: '/forecast',
                },
                {
                    title: 'POC',
                    icon: 'mdi-invoice-text-clock-outline',
                    path: '/poc',
                },
                {
                    title: 'Purchasing',
                    icon: 'mdi-cart-outline',
                    path: '/purchasing',
                },
                {
                    title: 'Accounting',
                    icon: 'mdi-clipboard-text-clock-outline',
                    path: '/accountant',
                },
                {
                    title: 'Foreign Trade',
                    icon: 'mdi-earth',
                    path: '/comex',
                },
                {
                    title: 'Invoicing',
                    icon: 'mdi-receipt-text-outline',
                    path: '/invoicing',
                },
                {
                    title: 'Suppliers',
                    icon: 'mdi-account-box-outline',
                    path: '/suppliers-tab',
                },
                {
                    title: 'Archive',
                    icon: 'mdi-archive-outline',
                    path: '/archive-projects',
                },
                {
                    title: 'chats',
                    icon: 'mdi-forum-outline',
                    path: '/project-chats',
                },
            ],
            productionItems: [
                {
                    title: 'Stock Room',
                    icon: 'mdi-database-outline',
                    path: '/stock-room',
                },
                {
                    title: 'Work Orders',
                    icon: 'mdi-factory',
                    path: '/work-orders',
                },
                {
                    title: 'Stadistics',
                    icon: 'mdi-chart-line',
                    path: '/work-orders-stadistics',
                },
                {
                    title: 'Packing',
                    icon: 'mdi-package-variant',
                    path: '/packing',
                },
                {
                    title: 'Shipment Planner',
                    icon: 'mdi-send-variant-clock-outline',
                    path: '/shipment-planner',
                },
            ],
            settingsItems: [
                {
                    title: 'Users',
                    icon: 'mdi-account-group-outline',
                    path: '/users',
                },
                {
                    title: 'Set Up',
                    icon: 'mdi-tools',
                    path: '/settings',
                },
            ],
            engineerItems: [
                {
                    title: 'Assign Engineer',
                    icon: 'mdi-view-dashboard-edit-outline',
                    path: '/assign-engineer',
                },
                {
                    title: 'Engineer',
                    icon: 'mdi-account-hard-hat-outline',
                    path: '/engineering',
                },
                {
                    title: 'History',
                    icon: 'mdi-clipboard-text-clock-outline',
                    path: '/engineering-history',
                },
            ],
            companyLogo: '',
            readStatistics: false,
            assignEngineers: false,
            engineeringHistory: false,
            uploadPreDesign: false,
            uploadCOMEX: false,
            user: {},
            operatorRole: true,
            archiveProject: false,
            liteWorkOrders: {},
            liteProjects: {},
        }
    },
    computed: {
        ...mapState(['settings', 'userRef', 'route']),
        taskGroup: function() {
            return (
                this.taskItems.find(
                    item => item.path == this.$router.currentRoute.name
                ) != undefined
            )
        },
        activeRoute() {
            return this.route
        },
    },
    async mounted() {
        try {
            this.filterByPermissions()
            const {
                data: { user },
            } = await API.getMyInfo()
            this.user = user
            this.operatorRole = user.operatorRole
            const liteWorkOrdersArray = await API.getLiteWorkOrders()
            const liteProjects = await API.getWoProjects()
            this.liteProjects = liteProjects || {}
            //transform array to object
            liteWorkOrdersArray.forEach(lwo => {
                lwo.projectManager = liteProjects[lwo.projectId]?.projectManager
                lwo.designManagers =
                    liteProjects[lwo.projectId]?.designManagers || []
                this.liteWorkOrders[lwo.id] = lwo
            })
            // Load settings to compute coordinator process IDs
            let coordinatedProcessIds = []
            try {
                const companyId = JSON.parse(localStorage.getItem('company'))
                const userId = JSON.parse(localStorage.getItem('userId'))
                const {
                    data: { settings },
                } = await API.getSettings(companyId ? { companyId } : {})
                const processesSetting = settings.find(
                    s => s.name === 'Processes'
                )
                if (processesSetting?.processes && userId) {
                    coordinatedProcessIds = processesSetting.processes
                        .filter(
                            p =>
                                Array.isArray(p.coordinators) &&
                                p.coordinators.includes(userId)
                        )
                        .map(p => p.id)
                }
            } catch (_) {
                coordinatedProcessIds = []
            }
            this.setupAlertsListener(user, coordinatedProcessIds)
            this.$nextTick(() => this.openGroupForCurrentRoute())
        } catch (error) {
            console.log(error)
        }
    },
    beforeDestroy() {
        if (this.alertsUnsubscribe) {
            this.alertsUnsubscribe()
        }
    },
    watch: {
        $route: {
            handler() {
                this.openGroupForCurrentRoute()
            },
        },
        settings(val) {
            val.forEach(setting => {
                if (setting && setting.name == 'Company') {
                    this.companyLogo = setting.generalInfo.image.imageURL
                }
            })
        },
    },
    methods: {
        ...mapActions(['resetStateAction']),
        ...mapMutations(['setRoute', 'setErrorItems']),
        isItemActive(path) {
            const current = this.$route.path
            return current === path || current.startsWith(path + '/')
        },
        openGroupForCurrentRoute() {
            const path = this.$route.path
            const containsPath = items =>
                items.some(
                    item =>
                        path === item.path || path.startsWith(item.path + '/')
                )
            if (containsPath(this.saleItems)) this.salesGroup = true
            else if (containsPath(this.engineerItems)) this.engineerGroup = true
            else if (containsPath(this.projectsItems)) this.projectGroup = true
            else if (containsPath(this.productionItems))
                this.productionGroup = true
            else if (containsPath(this.taskItems)) this.tasksGroup = true
            else if (containsPath(this.settingsItems)) this.settingsGroup = true
        },
        toggleGroup(key) {
            const map = {
                sales: 'salesGroup',
                engineer: 'engineerGroup',
                projects: 'projectGroup',
                production: 'productionGroup',
                tasks: 'tasksGroup',
                settings: 'settingsGroup',
            }
            const prop = map[key]
            if (prop) this[prop] = !this[prop]
        },
        dismissDrawer(listGroup) {
            if (listGroup == 'sales') {
                this.salesGroup = true
            } else if (listGroup == 'engineer') {
                this.engineerGroup = true
            } else if (listGroup == 'projects') {
                this.projectGroup = true
            } else if (listGroup == 'production') {
                this.productionGroup = true
            } else if (listGroup == 'tasks') {
                this.tasksGroup = true
            } else if (listGroup == 'settings') {
                this.settingsGroup = true
            }
            this.mini = true
        },
        filterByPermissions() {
            this.archiveProject = this.userRef.permissions.find(
                x => x == 'archiveProject'
            )
            this.readStatistics = this.userRef.permissions.find(
                x => x == 'readStatistics'
            )
            this.assignEngineers = this.userRef.permissions.find(
                x => x == 'assignEngineers'
            )
            this.engineeringHistory = this.userRef.permissions.find(
                x => x == 'engineeringHistory'
            )
            this.uploadPreDesign = this.userRef.permissions.find(
                x => x == 'uploadPreDesign'
            )
            this.calculations = this.userRef.permissions.find(
                x => x == 'calculations'
            )
            this.uploadCOMEX = this.userRef.permissions.find(
                x => x == 'comexModule'
            )
            this.tasks = this.userRef.permissions.find(x => x == 'readTasks')
            const suppliers = this.userRef.permissions.find(
                x => x == 'readSuppliers'
            )
            if (!suppliers) {
                const index = this.projectsItems.findIndex(
                    item => item.path === '/suppliers-tab'
                )
                if (index !== -1) this.projectsItems.splice(index, 1)
            }
            if (!this.readStatistics) {
                const index = this.saleItems.findIndex(
                    item => item.path === '/Statistics'
                )
                this.saleItems.splice(index, 1)
            }
            if (!this.assignEngineers) {
                const index = this.engineerItems.findIndex(
                    item => item.path === '/assign-engineer'
                )
                this.engineerItems.splice(index, 1)
            }
            if (!this.engineeringHistory) {
                const index = this.engineerItems.findIndex(
                    item => item.path === '/engineering-history'
                )
                this.engineerItems.splice(index, 1)
            }
            if (!this.uploadPreDesign) {
                const index = this.engineerItems.findIndex(
                    item => item.path === '/engineering'
                )
                this.engineerItems.splice(index, 1)
            }
            if (!this.uploadCOMEX) {
                const index = this.projectsItems.findIndex(
                    item => item.path === '/comex'
                )
                this.projectsItems.splice(index, 1)
            }
            if (!this.calculations) {
                const index = this.saleItems.findIndex(
                    item => item.path === '/calculations'
                )
                this.saleItems.splice(index, 1)
            }
            if (!this.userRef.permissions.find(x => x == 'seePocSection')) {
                const index = this.projectsItems.findIndex(
                    item => item.path === '/poc'
                )
                this.projectsItems.splice(index, 1)
            }
            const hasWithPoAccounting = this.userRef.permissions.find(
                x => x == 'withPoAccounting'
            )
            const hasAccountingHistory = this.userRef.permissions.find(
                x => x == 'accountingHistory'
            )
            const hasWithOutPoAccounting = this.userRef.permissions.find(
                x => x == 'withOutPoAccounting'
            )
            if (
                !isAccountingEnabled(this.companyId) ||
                (!hasWithPoAccounting &&
                    !hasAccountingHistory &&
                    !hasWithOutPoAccounting)
            ) {
                const index = this.projectsItems.findIndex(
                    item => item.path === '/accountant'
                )
                if (index !== -1) {
                    this.projectsItems.splice(index, 1)
                }
            }
        },
        closeMenu() {
            this.mini = true
        },
        setupAlertsListener(user, coordinatedProcessIds = []) {
            const userId = JSON.parse(localStorage.getItem('userId'))
            const hasApprovalPermission = user.permissions?.includes(
                'approveProductionAlerts'
            )
            const alertsRef = firestore
                .collection('companies')
                .doc(this.companyId)
                .collection('alerts')

            this.alertsUnsubscribe = alertsRef.onSnapshot(
                snapshot => {
                    let count = 0
                    snapshot.forEach(doc => {
                        const woAlerts = { id: doc.id, ...doc.data() }
                        const wo = this.liteWorkOrders[woAlerts.id]
                        for (const alert of Object.values(
                            woAlerts.alerts || {}
                        )) {
                            if (
                                alert.status !== 'pending' &&
                                alert.status !== 'pending_approval'
                            )
                                continue

                            if (
                                (alert.currentStep === 'supervisor' &&
                                    (hasApprovalPermission ||
                                        coordinatedProcessIds.includes(
                                            alert.processId
                                        ))) ||
                                alert.createdBy === userId
                            ) {
                                count++
                            } else if (
                                (alert.currentStep === 'pm_designer' &&
                                    userId &&
                                    [
                                        wo?.projectManager,
                                        wo?.createdBy,
                                        ...(wo?.designManagers ||
                                            this.liteProjects[wo?.projectId]
                                                ?.designManagers ||
                                            []),
                                    ].includes(userId)) ||
                                alert.createdBy === userId
                            ) {
                                count++
                            } else if (
                                (alert.currentStep === 'supervisor_approval' &&
                                    (hasApprovalPermission ||
                                        coordinatedProcessIds.includes(
                                            alert.processId
                                        ))) ||
                                alert.createdBy === userId
                            ) {
                                count++
                            }
                        }
                    })
                    this.alertsCount = count
                },
                error => {
                    console.error('Error in alerts listener:', error)
                }
            )
        },
        signOut: async function() {
            try {
                this.loading = true
                localStorage.clear()
                //
                await auth().signOut()
                this.$router
                    .replace({ name: 'sign in' })
                    .catch(error => error && null)
                this.resetStateAction()
                this.loading = false
            } catch (error) {
                this.error = true
                this.errorMsg = error.message
            } finally {
                // unsubscribe from topic for notifications
                if (messaging) {
                    const currentToken = await messaging.getToken({ vapidKey })
                    await API.unsubscribeFromTopic(currentToken).catch(
                        error => {
                            console.log(error.message)
                        }
                    )
                }
            }
        },
    },
}
</script>

<style scoped>
.v-navigation-drawer {
    transform: translateX(0%) !important;
    width: 56px;
    z-index: 99 !important;
    overflow-x: hidden;
}

.v-navigation-drawer >>> .v-navigation-drawer__content {
    overflow-x: hidden;
}

.nav-drawer-inner {
    min-height: 0;
    overflow-x: hidden;
    max-width: 100%;
}

.nav-drawer-list {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
}

.nav-drawer-item--active {
    background: rgba(25, 118, 210, 0.12);
    position: relative;
}

.nav-drawer-item--active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #1976d2;
    border-radius: 0 2px 2px 0;
}

.nav-drawer-footer .logout-item:hover {
    background: rgba(244, 67, 54, 0.08);
}

.nav-drawer-footer .logout-item .v-icon {
    color: rgba(0, 0, 0, 0.6);
}
</style>
